export const COOKIE_DURATION = 30 * 24 * 60 * 60;
export const COOKIE_PREFIX = '__';

export const LEGACY_QUERY_PARAMS = {
    atid: 'atid', // Allani redirect transaction Id
    ath: 'ath',
    atid2: 'atid2', // Domodi redirect transaction id
    ath2: 'ath2',
    atu: 'atu',
    ats: 'ats',
    att: 'att'
};

export const GLOBAL_QUERY_PARAMS = {
    source_tid: 'wph_tid', // Redirect Click id from source page
    source_cid: 'wph_cid', // Shop/Page id source page
    source_uid: 'wph_uid', // User id on source page
    source_vid: 'wph_vid', // Visit id on source page
    source_hash: 'wph_hash', // SHA1 hash from params
    source_host: 'wph_host', // Source host
    source_clid: 'wpclid' // Source click id
};

export const SESSION_PARAMS = {
    user: 'wph_a',
    sessionTimeout: 'wph_st'
};

// use to override cookie naming pattern and duration
export const COOKIES_MAP = {
    wpclid: { name: '__wph_clid' },
    wph_a: { duration: 365 * 24 * 60 * 60 }, // User id cookie; lasts a year
    wph_st: { duration: 24 * 60 * 60 }, // Helper session cookie; 24h lifetime
    wpcpx: { duration: 60 * 60 * 24 * 365 * 2 } // RODO cookie; lasts 2 years
};

export const ID_LENGTH = 10;

export const WPCPX_COOKIE = 'WPcpx';
export const WPADUID_COOKIE = 'WPaduid';

export const MULTIPLE_INITS = {
    same_id: 1, // Marks a second+ 'init' event with repeated client_id
    different_id: 2 // Marks a second+ 'init' event with a new client_id
};

export const LOGGER_VERBOSITY_KEY = '__wphpx_logger_verbosity_level';
